import useGetTodaysDispatcher from 'src/app/hooks/useGetTodaysDispatcher'

const DailyDispatchLabel = ({ users }) => {
  const { id } = useGetTodaysDispatcher()

  if (!id) return `Not Set`
  return `${users.find(u => id === u.id).name}`
}
export default DailyDispatchLabel
